const applyCountsToItem = (item, counts, isLoading) => {
	if (!item.chip) {
		return item;
	}

	const count = counts[item.id];
	let label;

	if (isLoading) {
		label = '…';
	} else if (count !== undefined) {
		label = String(count);
	} else {
		label = item.chip.label;
	}

	return {
		...item,
		chip: {
			...item.chip,
			label,
		},
	};
};

export const mergeMenuCounts = (menuItems, counts, isLoading = false) => {
	return menuItems.map((group) => ({
		...group,
		children: group.children?.map((menuItem) => {
			if (menuItem.type === 'item') {
				return applyCountsToItem(menuItem, counts, isLoading);
			}

			return {
				...menuItem,
				children: menuItem.children?.map((item) =>
					applyCountsToItem(item, counts, isLoading),
				),
			};
		}),
	}));
};
